import {
  LearnerBusinessId,
  ReplacementFilesComponentDocumentsDto,
  ReplacementFilesComponentLearnersDto,
  ReplacementFilesComponentsDto,
} from '@cambridgeassessment/lib-ee-commons';

export const RESET_ENTRIES_LIST = '@REPLACEMENT_FILES/RESET_ENTRIES_LIST';
export const SET_IS_LOADING_LEARNERS = '@REPLACEMENT_FILES/SET_IS_LOADING_LEARNERS';
export const UPDATE_LEARNERS_RESUBMISSION_STATUS = '@REPLACEMENT_FILES/UPDATE_LEARNERS_RESUBMISSION_STATUS';
export const UPDATE_DOCUMENTS_RESUBMISSION_STATUS = '@REPLACEMENT_FILES/UPDATE_DOCUMENTS_RESUBMISSION_STATUS';
export const COMPONENT_RESUBMITTION_SUCCESS = '@REPLACEMENT_FILE/COMPONENT_RESUBMITTION_SUCCESS';
export const COMPONENT_RESUBMISSION_STATUS_UPDATED_SUCCESS =
  '@REPLACEMENT_FILE/COMPONENT_RESUBMISSION_STATUS_UPDATED_SUCCESS';
export const ADD_COMPONENTS = '@REPLACEMENT_FILES/ADD_COMPONENTS';
export const ADD_COMPONENT_LEARNERS = '@REPLACEMENT_FILES/ADD_COMPONENT_LEARNERS';
export const SET_IS_LOADING_COMPONENTS = '@REPLACEMENT_FILES/SET_IS_LOADING_COMPONENTS';
export const ADD_COMPONENT_DOCUMENTS = '@REPLACEMENT_FILES/ADD_COMPONENT_DOCUMENTS';
export const SET_IS_SAVING_RESUBMISSION_STATUS = '@REPLACEMENT_FILES/SET_IS_SAVING_RESUBMISSION_STATUS';
export const SET_IS_LINKED_CANDIDATE_MODAL_OPEN = '@REPLACEMENT_FILES/SET_IS_LINKED_CANDIDATE_MODAL_OPEN';
export const UPDATE_ASSOCIATED_LEARNERS = '@REPLACEMENT_FILES/UPDATE_ASSOCIATED_LEARNERS';
export const SET_SELECTED_LEARNER = '@REPLACEMENT_FILES/SET_SELECTED_LEARNER';

export interface ResetEntriesList {
  type: typeof RESET_ENTRIES_LIST;
}

export interface SetIsLoadingLearners {
  type: typeof SET_IS_LOADING_LEARNERS;
  payload: {
    componentIndex: number;
    isLoadingEntries: boolean;
  };
}

export interface SetIsLoadingComponents {
  type: typeof SET_IS_LOADING_COMPONENTS;
  payload: {
    isLoadingComponents: boolean;
  };
}

export interface UpdateLearnersResubmissionStatus {
  type: typeof UPDATE_LEARNERS_RESUBMISSION_STATUS;
  payload: {
    entryIndex: number;
    componentIndex: number;
    availableForResubmission: boolean;
    associatedLearners: LearnerBusinessId[];
  };
}

export interface UpdateAssociatedLearners {
  type: typeof UPDATE_ASSOCIATED_LEARNERS;
  payload: {
    associatedLearners: LearnerBusinessId[];
  };
}

export interface SetSelectedLearner {
  type: typeof SET_SELECTED_LEARNER;
  payload: {
    selectedLearner: {
      learnerBid: ReplacementFilesComponentLearnersDto;
      entryIndex: number;
      componentIndex: number;
      val: boolean;
    };
  };
}

export interface UpdateDocumentsResubmissionStatus {
  type: typeof UPDATE_DOCUMENTS_RESUBMISSION_STATUS;
  payload: {
    componentIndex: number;
    documentId: ReplacementFilesComponentDocumentsDto['section']['id'];
    availableForResubmission: boolean;
  };
}

export interface ComponentResubmissionSuccess {
  type: typeof COMPONENT_RESUBMITTION_SUCCESS;
  payload: {
    componentIndex: number;
    availableForResubmission: boolean;
  };
}

export interface ComponentResubmissionStatusUpdatedSuccess {
  type: typeof COMPONENT_RESUBMISSION_STATUS_UPDATED_SUCCESS;
  payload: {
    componentIndex: number;
    isAllSelected: boolean;
    isAllAbsent: boolean;
  };
}

export interface AddComponents {
  type: typeof ADD_COMPONENTS;
  payload: {
    components: ReplacementFilesComponentsDto[];
  };
}

export interface AddComponentLearners {
  type: typeof ADD_COMPONENT_LEARNERS;
  payload: {
    componentIndex: number;
    entries: ReplacementFilesComponentLearnersDto[];
    nextUrl?: string;
  };
}

export interface AddComponentDocuments {
  type: typeof ADD_COMPONENT_DOCUMENTS;
  payload: {
    componentIndex: number;
    documents: ReplacementFilesComponentDocumentsDto[];
  };
}

export interface SetIsSavingResubmissionStatus {
  type: typeof SET_IS_SAVING_RESUBMISSION_STATUS;
  payload: {
    isSaving: boolean;
  };
}

export interface SetIsLinkedCandidateModalOpen {
  type: typeof SET_IS_LINKED_CANDIDATE_MODAL_OPEN;
  payload: {
    setOpen: boolean;
  };
}

export type EntriesActionTypes =
  | ResetEntriesList
  | SetIsLoadingLearners
  | UpdateLearnersResubmissionStatus
  | UpdateDocumentsResubmissionStatus
  | ComponentResubmissionSuccess
  | ComponentResubmissionStatusUpdatedSuccess
  | AddComponents
  | AddComponentLearners
  | SetIsLoadingComponents
  | AddComponentDocuments
  | SetIsSavingResubmissionStatus
  | SetIsLinkedCandidateModalOpen
  | UpdateAssociatedLearners
  | SetSelectedLearner;
